import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UserManagementService } from '../user-management/user-management.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { EmailTemplateService } from '../email-template/service/email-template.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogCensusColumnAdminComponent } from '../dialog-census-column-admin/dialog-census-column-admin.component';
import { FormControl } from '@angular/forms';
import { MipsService } from 'src/app/services/Modules/mips.service';
import { lastValueFrom } from 'rxjs';
import * as global from '../../includes/global'
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-manage-companies',
  templateUrl: './manage-companies.component.html',
  styleUrls: ['./manage-companies.component.css']
})
export class ManageCompaniesComponent implements OnInit, OnDestroy {
  global = global;
  companies: any = [];
  dataSource: any = new MatTableDataSource([]);
  displayedColumns: string[] = ['active', 'name', 'code', 'created_at', 'providerCount', 'facilityCount',
    'pccFacilityCount',
    // 'nonPccFacilityCount',
    // 'email',
    // 'providerCount',
    // 'carry_charges',
    // 'census_inactive_reason',
    // 'signed_notes',
    'permissions',
    // 'patient_search_accross_company',
    // 'census_cols',
    // 'allow_hl',
    'operations'];
  @ViewChild(MatSort) sort: MatSort;
  isShowCompanyEmail: boolean = false;
  isManageCompaniesVisible: boolean = true;
  emailTemplateSubscription: any;
  isCompanySettingsVisible: boolean = false;
  currentCompany: any;
  providersCount = [];
  FacilitiesCount = [];
  pccFacilitiesCount = [];
  company_id: any;
  defaultTabIndex: number = 0;
  charge_edit_duration = 0;
  isWoundCompany: boolean = false;
  reportsNames =
    [{ title: 'DNS Report', url: 'dns-report', selected: false, user_type: [] },
    { title: 'DNS Healing Report', url: 'dns-healing-report', selected: false, user_type: [] },
    // { title: 'DNS Tissue Analytic Report', url: 'dns-tissue-analytic-report', selected:false , user_type:[]},
    { title: 'Post-Rounds Wound Report', url: 'dns-tissue-analytic-report', selected: false, user_type: [] },
    { title: 'QAPI Report', url: 'qapi-report', selected: false, user_type: [] },
    { title: 'Visit Summary Report', url: '', selected: false, user_type: [] },
    { title: 'Visit Report', url: 'visit-report', selected: false, user_type: [] },
    { title: 'Discharged Patient Report', url: 'discharged-patient-report', selected: false, user_type: [] },
    { title: 'Missed Facility Report', url: 'missed-facility-report', selected: false, user_type: [] },
    { title: 'Debridement Report', url: 'debridement-report', selected: false, user_type: [] },
    { title: 'Healing Success Rate Report', url: 'healing-success-rate-report', selected: false, user_type: [] },
    { title: 'UWH Type Tabular Report', url: 'uwh-type-tabular-report', selected: false, user_type: [] },
    { title: 'Kent Visit Report', url: 'kent-visit-report', selected: false, user_type: [] },
    { title: 'Charges Report', url: 'admin-charges-report', selected: true, user_type: [] },
    { title: 'LOS Report', url: 'los-report', selected: true, user_type: [] },
    { title: 'BIMS/PHQ9 Report', url: 'bims-phq9-patient-report' , selected:false , user_type:[]},
    ];
  @Input() dataForMyCompanies: any;
  myAssosiationSide: boolean;
  adminId: any;
  parentCompanyId: any;
  activeFilter: any;
  categoryFilter: any;
  mipsQuestions: any[] = [];
  showMips: boolean = false;
  showNurseCensus: boolean = false;
  showNursePatients: boolean = false;
  allPermissions = [];
  parentCompanyCategory;
  currentUser: any;
  disableMips: boolean = false;
  findTagPermissions: any;
  addPatientsToCensusPermissionId: any;
  previousSelection: string[] = [];
  
  constructor(
    private companyService: CompanyService,
    private _location: Location,
    private router: Router,
    private userManagementService: UserManagementService,
    private toastr: ToastrService,
    private _commonService: CommonService,
    private _emailTemplateService: EmailTemplateService,
    private dialog: MatDialog,
    private mipsService: MipsService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.currentUser = this.authService.currentUser;
  }

  async ngOnInit() {
    if(!this.currentUser.product_owner) {
      if(this.currentUser.admin_type != 'system_admin' && this.currentUser.admin_type != 'full_admin')
        this.disableMips = true;
    }
    await this.getAllPermissions();
    this.activeFilter = 'true';
    this.categoryFilter = 'company';

    
    if (this.dataForMyCompanies?.assosiation) {
      this.myAssosiationSide = true;
      this.adminId = this.dataForMyCompanies.adminId;
      this.parentCompanyId = this.dataForMyCompanies.parentCompanyId;
      this.displayedColumns = ['name', 'code', 'created_at', 'providerCount', 'facilityCount',
        'pccFacilityCount',
        // 'nonPccFacilityCount',
        // 'email',
        // 'providerCount',
        // 'carry_charges',
        // 'census_inactive_reason',
        // 'signed_notes',
        'permissions',
        // 'patient_search_accross_company',
        // 'census_cols',
        // 'allow_hl',
        'operations'];
        this.categoryFilter='practice';
    }
    if (window.location.pathname.includes('woundcare')) {
      this.reportsNames.filter(woundSetting => {
        if (woundSetting.title == 'DNS Healing Report') { woundSetting.title = 'Wound Report'; return woundSetting } else {
          return woundSetting;
        }
      })
    }
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data:
      { name: string }, filterValue: string) =>
      data.name.trim().toLowerCase().indexOf(filterValue?.toLowerCase()) !== -1;

    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'created_at': return new Date(item.createdAt);
        default: return item[property];
      }
    };
    this.initCompanies("true");

    this.emailTemplateSubscription = this._emailTemplateService.castIsCompanyVisible.subscribe((isShowCompanyEmail) => {
      this.isShowCompanyEmail = isShowCompanyEmail;
    });
  }
  ngOnDestroy(): void {
    if (this.emailTemplateSubscription) {
      this.emailTemplateSubscription.unsubscribe();
    }
  }

  async getAllPermissions() {
    const response: any = await lastValueFrom(this.companyService.getAllPermissions({}, {}));
    if (response.status === 200) {
      this.allPermissions = response.data;
      this.findTagPermissions = this.allPermissions.find(permission => permission.key == 'should_show_tag');
      this.findTagPermissions = this.findTagPermissions._id;
      this.addPatientsToCensusPermissionId = this.allPermissions.find(permission => permission.key === 'add_patients_to_census')?._id;
    }
  }

  saveSettings() {
    this.companyService.saveCompanyReportSettings(this.currentCompany._id, this.reportsNames).subscribe((response: any) => {
      this.toastr.success('Settings Updated Successfully');
    })
  }
  updateIPAReportSetting(event) {
    if (event) {
      this.reportsNames.push({ title: 'IPA Report', url: 'ipa-report', selected: true, user_type: [] });
      this.getSettings();
    }
    else {
      this.reportsNames = this.reportsNames.filter((report) => {
        return report.title !== 'IPA Report'
      })
      this.getSettings();
    }
  }

getSettings() {
    if (this.currentCompany.should_show_ipa) {
      let idx = this.reportsNames.findIndex((report) => {
        return report.title == 'IPA Report'
      });
      if (idx === -1) {
        this.reportsNames.push({ title: 'IPA Report', url: 'ipa-report', selected: true, user_type: [] })
      }

    }
    this.companyService.getCompanyReportSettings(this.currentCompany._id).subscribe((response: any) => {
      if(response.charge_edit_duration){
        this.charge_edit_duration = response.charge_edit_duration;
      }
      if (response.data?.length) {
        response.data.forEach(element => {
          const index = this.reportsNames.findIndex(e => e.url == element.url);
          if (index >= 0) {
            this.reportsNames[index].selected = element.selected;
            this.reportsNames[index].user_type = element.user_type;
          }
        });
      } else {
        this.refreshSettings();
        this.saveSettings();
      }
    })
  }  
  saveChargeSetting(){
    this.companyService.saveChargeSetting(this.currentCompany._id,this.charge_edit_duration).subscribe((response: any) => {
      if(response.status == 200){
        this.toastr.success('Charge Edit Duration Updated Successfully');
      }
    })
  }
  async getChargeSetting() {
    try {
      const response: any = await lastValueFrom(this.companyService.getChargeSetting(this.currentCompany._id)) as any ;
      if(response.status === 200 && response.charge_edit_duration){
        this.charge_edit_duration = response.charge_edit_duration;
      } else {
        this.charge_edit_duration = 0;
      }
    } catch (error) {
      throw new Error(error);    }
  }
  async initCompanies(filter?) {
    let query = {};

    if (this.myAssosiationSide) {
      const getCompany = await this.companyService.getCompanyName(this.parentCompanyId).toPromise()
      this.parentCompanyCategory = getCompany.data.category;
      if (this.parentCompanyCategory == 'practice') {
        query = {
          adminId: this.adminId,
          parentCompanyId: this.parentCompanyId,
          getAllChilds: true
        }
      } else {
        query = {
          adminId: this.adminId,
          parentCompanyId: this.parentCompanyId,
        }
      }
      if (getCompany) {
      this.companyService.getAllAssosiatedCompaniesWithCount(query).subscribe((response: any) => { 
        if (response.status == 200) {
          this.companies = response.data;
          this.companies.forEach(element => {
            element.name = element.name.toLowerCase();
            element.firstSelectedPermission = this.allPermissions.find(permissions => element.permissions.includes(permissions._id)) || {};
          });
          this.dataSource.data = this.companies;
          this.dataSource.sort = this.sort;
          this.applyCompanyFilter(filter);
        }
        else if (response.status == 403) {
          this.toastr.error(response.message, "ERROR");
        }

      })
     }
    } else {
      this.companyService.getAllCompaniesWithCount().subscribe((response: any) => {
        if (response.status == 200) {
          this.companies = response.data;
          this.companies.forEach(element => {
            element.name = element.name.toLowerCase();
            element.firstSelectedPermission = this.allPermissions.find(permissions => element.permissions.includes(permissions._id)) || {};
          });
          this.dataSource.data = this.companies;
          this.dataSource.sort = this.sort;
          this.applyCompanyFilter(filter);
        }
        else if (response.status == 403) {
          this.toastr.error(response.message, "ERROR");
        }

      })
    }
  }

  applyCompanyFilter(filterValue: any) {
    this.activeFilter = filterValue;
    // if (filterValue === "all") {
    //   this.dataSource.data = this.companies;
    // } else if (filterValue === "false") {
    //   this.dataSource.data = this.companies.filter(company => company.is_active == false);
    // } else {
    //   this.dataSource.data = this.companies.filter(company => company.is_active == true);
    // }

    if (this.activeFilter === "all") {
      this.dataSource.data = this.companies.filter((company: any) => {
        if (this.categoryFilter == "company") {
          return (company.category == 'company');
        } else if (this.categoryFilter == "practice") {
          return (company.category == 'practice');
        } else {
          return true;
        }
      });
    } else if (this.activeFilter == 'false') {
      this.dataSource.data = this.companies.filter((company: any) => {
        if (this.categoryFilter == "company") {
          return (company.category == 'company' && company.is_active == false);
        } else if (this.categoryFilter == "practice") {
          return (company.category == 'practice' && company.is_active == false);
        } else {
          return (company.is_active == false);
        }
      });
    } else if (this.activeFilter == 'true') {
      this.dataSource.data = this.companies.filter((company: any) => {
        if (this.categoryFilter == "company") {
          return (company.category == 'company' && company.is_active == true);
        } else if (this.categoryFilter == "practice") {
          return (company.category == 'practice' && company.is_active == true);
        } else {
          return (company.is_active == true);
        }
      });
    }

    this.dataSource.sort = this.sort;
  }

  applyCategoryFilter(filterValue: any) {
    this.categoryFilter = filterValue;

    if (this.categoryFilter === "all") {
      this.dataSource.data = this.companies.filter((company: any) => {
        if (this.activeFilter == "false") {
          return (company.is_active == false);
        } else if (this.activeFilter == "true") {
          return (company.is_active == true);
        } else {
          return true;
        }
      });
    } else if (this.categoryFilter == 'company') {
      this.dataSource.data = this.companies.filter((company: any) => {
        if (this.activeFilter == "false") {
          return (company.category == 'company' && company.is_active == false);
        } else if (this.activeFilter == "true") {
          return (company.category == 'company' && company.is_active == true);
        } else {
          return (company.category == 'company');
        }
      });
    } else if (this.categoryFilter == 'practice') {
      this.dataSource.data = this.companies.filter((company: any) => {
        if (this.activeFilter == "false") {
          return (company.category == 'practice' && company.is_active == false);
        } else if (this.activeFilter == "true") {
          return (company.category == 'practice' && company.is_active == true);
        } else {
          return (company.category == 'practice');
        }
      });
    }

    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: any) {
    this.dataSource.filter = filterValue;
  }

  addCompany() {
    this.company_id = this.route.parent.snapshot.params.id;
    this.router.navigateByUrl(`company/${this.company_id}/register-company`)
  }

  goBack() {
    this.refreshSettings();
    this._location.back();
  }
  refreshSettings() {
    this.isWoundCompany = false;
    if (this.currentCompany.company_type == 'Wound') {
      this.isWoundCompany = true;
    }
    this.reportsNames = this.reportsNames.map((e: any) => { return { title: e.title, url: e.url, selected: false, user_type: e.user_type } });
  }
  changeUserActiveStatus(element, status) {
    this.userManagementService.changeUserActiveStatus(element.user_id._id, status).subscribe((response: any) => {
      if (response.status == 200) {
        this.toastr.success(response.message, 'Success');
      } else {
        this.toastr.error(response.message, 'Failed');
      }
    })
  }

  changeCompanyActiveStatus(element, status) {
    this.companyService.changeCompanyActiveStatus(element._id, status).subscribe((response: any) => {
      if (response.status == 200) {
        this.initCompanies((!status).toString());
        this.toastr.success(response.message, 'Success');

      } else {
        this.toastr.error(response.message, 'Failed');
      }
    })
  }
  changeCarryForwardStatus(element, status) {
    this.companyService.changeCompanyCarryForwardtatus(element._id, status).subscribe((response: any) => {
      if (response.status == 200) {
        this.toastr.success(response.message, 'Success');
      } else {
        this.toastr.error(response.message, 'Failed');
      }
    })
  }
  
  companyClicked(company) {
    // 
    // this.router.navigateByUrl(`/company/${company._id}/user-management`) 
    this._commonService.setCompanySelected(company)
    // this.router.navigateByUrl(`/company/${company._id}/dashboard`) 
    this.router.navigateByUrl(`/dashboard`, { skipLocationChange: true }).then(() =>
      this.router.navigate([`/company/${company._id}/dashboard`]));
  }
  loadCompanyEmail() {
    this.isManageCompaniesVisible = false;
    this.isShowCompanyEmail = true;
  }
  updateComapny(element, field, value) {
    let data = {
      _id: element._id,
      [field]: value
    }
    this.companyService.updateCompany(data).subscribe((response: any) => {
      if (response.status == 200) {
        this.toastr.success(response.message, 'Success');
      } else {
        this.toastr.error(response.message, 'Failed');
      }
    })
  }


  updateCensusColumnSettings(company_id = null) {
    const obj = {
      company_id: company_id
    }
    if (!company_id) return;

    let dialogRef = this.dialog.open(DialogCensusColumnAdminComponent, {
      data: obj,
      minWidth: '50%'
    });

    dialogRef.afterClosed().subscribe(async (data) => {
      if (data) {
        this.toastr.success('Census Settings Updated.');
      } else {
        console.log("canceled census column dialogue");
      }
    });

  }

  updateCurrentCompany($event) {
    this.companies.forEach(element => {
      if (element._id == $event._id) {
        element.logo_aws_path = $event.logo_aws_path;
        element.monogram_aws_path = $event.monogram_aws_path;
      }
    });
    // this.initCompanies();
    this.currentCompany = $event;
    if(!this.currentUser.product_owner) {
      if((this.currentUser.admin_type != 'system_admin' && this.currentUser.admin_type != 'full_admin')
      || this.currentCompany._id.toString() != this.currentUser.company_id.toString())
        this.disableMips = true;
    }
    this.dataSource.data = [];
    this.dataSource.data = this.companies;
    this.dataSource.sort = this.sort;
    this.applyCompanyFilter("true");
    //console.log('this companies', this.companies);
  }

  async getAllMips(company) {
    let res: any = await this.mipsService.getAllMips().toPromise();
    if (res.status == 200) {
      this.mipsQuestions = res.data.array;
      this.mipsQuestions.forEach((mip) => {
        if (mip.associated_company_ids.includes(company._id)) {
          mip.is_active_for_company = true;
        } else {
          mip.is_active_for_company = false;
        }
      })
    }
  }
  async saveMipsSetting(event, currentCompany, mip) {
    let mipDetail = { mipId: mip._id, mip_quality_number: mip.quality_number }
    let res: any = await this.mipsService.saveMipsSetting(event.checked, currentCompany._id, mipDetail).toPromise();
    if (res.status == 200) {
    }
  }
  async toggleCompanyMips(event, currentCompany) {
    this.showMips = event.checked;
    let res: any = await this.mipsService.enableCompanyMips(event.checked, currentCompany._id).toPromise();
    if (res.status == 200) {
      if(event.checked){
        this.toastr.success('Enable Measure Reporting successfully activated')
      }
      else{
        this.toastr.success('Enable Measure Reporting successfully deactivated')
      }
    }
  }
  getCompanyMipsEnabledStatus(company) {
    this.companyService.getCompanyName(company._id).subscribe((response: any) => {
      if (response.status == 200) {
        this.showMips = response.data.enable_company_mips;
      }
    })
  }
  async updateNurseCensusSettings(event, currentCompany) {
    this.showNurseCensus = event.checked;
    let res: any = await this.mipsService.updateNurseCensusSettings(event.checked, currentCompany._id).toPromise();
    if (res.status == 200) {
    }
  }
  async updateNursePatientsSettings(event, currentCompany) {
    this.showNursePatients = event.checked;
    let res: any = await this.mipsService.updateNursePatientsSettings(event.checked, currentCompany._id).toPromise();
    if (res.status == 200) {
    }
  }
  getCompanyNurseSettings(company) {
    this.companyService.getCompanyName(company._id).subscribe((response: any) => {
      if (response.status == 200) {
        this.showNurseCensus = response.data.enable_nurse_census;
        this.showNursePatients = response.data.enable_nurse_patients;
      }
    })
  }

  updateFacesheetSettinginList($event) {
    this.companies.forEach(element => {
      if (element._id == $event._id) {
        element.should_upload_facesheet = $event.should_upload_facesheet;
        element.should_extract_facesheet_data = $event.should_extract_facesheet_data;
      }
    });
    this.currentCompany = $event;
    this.dataSource.data = [];
    this.dataSource.data = this.companies;
    this.dataSource.sort = this.sort;
    this.applyCompanyFilter("true");
  }

  getProviderTotalCount() {
    let sum = this.dataSource.data.filter(f => f.is_active && f.providers).map(p => p.providers?.providerCount).reduce((pv, cv) => pv + cv, 0);
    return sum;
  }

  getFacilitiesTotalCount() {
    let sum = this.dataSource.data.filter(f => f.is_active && f.facilities).map(p => p.facilities?.facilityCount).reduce((pv, cv) => pv + cv, 0);
    return sum;
  }

  getPccFacilitiesTotalCount() {
    let sum = this.dataSource.data.filter(f => f.is_active && f.pccFacilties).map(p => p.pccFacilties?.PCCfacilityCount).reduce((pv, cv) => pv + cv, 0);
    return sum;
  }
  onTabChange(event) {
    this.defaultTabIndex = event.index;
  }
  async changeCompanyPermission(companyId, permissions) {
    let findTagPermissionsId = permissions.find(id => id == this.findTagPermissions)
    let findAddPatientsToCensusPermissionsId = permissions.find(id => id == this.addPatientsToCensusPermissionId);
    const filter = {
      _id: companyId
    };
    let updateQuery = {
      $set: {
        permissions
      }
    }
    const options = {};
    if (findTagPermissionsId)
      updateQuery.$set['should_show_tag'] = true;
    else
      updateQuery.$set['should_show_tag'] = false;

    const newlySelected = permissions.find(value => !this.previousSelection.includes(value));
    const newlyUnselected = this.previousSelection.find(value => !permissions.includes(value));
    this.previousSelection = permissions;
    
    const key = this.allPermissions.find(permission => permission._id === (newlySelected ? newlySelected : newlyUnselected))?.key;

    if (key === 'bh_assessment_tool') {
      options['bh_assessment_tool'] = newlySelected ? true : false;
    }

    if (findAddPatientsToCensusPermissionsId)
      options['add_patients_to_census'] = true;
    else
      options['add_patients_to_census'] = false;

    const response: any = await lastValueFrom(this.companyService.modifyCompany(filter, updateQuery, options));
    if (response.status === 200) {
      this.dataSource.data = [];
      for (const company of this.companies) {
        if (company._id === companyId) {
          company.permissions = permissions;
          company.firstSelectedPermission = this.allPermissions.find(permission => company.permissions.includes(permission._id)) || {};
        }
      }
      this.dataSource.data = this.companies;
      this.applyCompanyFilter(this.activeFilter);
      this.toastr.success('Permission Updated', 'Success');
    }
  }
  
  setPreviousSelection(permissions) {
    this.previousSelection = permissions;
  }
}
